import { RoleMap } from "./Constants";

export const RoleModalMessages = {
  AddRole(user, roleName) {
    if (RoleMap.Student === roleName && user.roles.includes(RoleMap.Mentor)) {
      return `<p>Are you sure you want to <strong>add the ${roleName} role</strong> to <strong>${user.firstName} ${user.lastName} (${user.email})?</strong><br /> Doing so will remove the ${RoleMap.Mentor} role <strong>and unlink all students currently assigned to this user</strong>.</p>`;
    } else if (
      RoleMap.Mentor === roleName &&
      user.roles.includes(RoleMap.Student)
    ) {
      return `<p>Are you sure you want to <strong>add the ${roleName} role</strong> to <strong>${user.firstName} ${user.lastName} (${user.email})?</strong><br />Doing so will remove the ${RoleMap.Student} role <strong>and unlink their assigned mentor</strong>.</p>`;
    } else {
      return `<p>Are you sure you want to <strong>add the ${roleName} role</strong> to <strong>${user.email}?</strong></p>`;
    }
  },
  RemoveRole(user, roleName) {
    return `<p>Are you sure you want to <strong>remove the ${roleName} role</strong> from <strong>${user.firstName} ${user.lastName} (${user.email})?</strong></p>`;
  },
  AddRoleYesAction(roleName) {
    return `add the ${roleName} role`;
  },
  RemoveRoleYesAction(roleName) {
    return `remove the ${roleName} role`;
  },
  CommonCancelAction() {
    return "cancel";
  },
  AddTitle() {
    return "Confirm add role:";
  },
  RemoveTitle() {
    return "Confirm remove role:";
  }
};
